// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__GgY8e","col":"styles_col__t2VuF"};